/* eslint-disable max-len */
import React, { useState, useContext, useEffect } from 'react';
import { Box, FormControlLabel, Checkbox, Tooltip, Grid, Switch, Stack, Button, IconButton, styled, FormControl, Select, MenuItem, RadioGroup, Radio } from '@mui/material';
import { isEmpty } from 'lodash';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import Charts from './charts';
import Notification from '../../../shared/notification-modal';
import { defaultModalOptions } from '../../../shared/constantVariable';
import { saveFormDataInLocalStorage } from '../../../shared/feed-common-feature';
import Dashboard from './dashboard';
import ArgoDashboard from './argo_dashboard';
import { RoContext, CLRoContext } from './contextcall';
import './argo.scss';
import { Products, getRegionAccess, getRegion, getDefaultValue, getUserType } from '../../../shared/Products';

export default function Argo(props) {
  const { handleCloseRoModal, roDetails, handleCloseRo, setIsShowErrorMessage, feedName, dbTransactionDetails, translateObject } = props;
  const { id } = roDetails;
  const handleSaveRocontextTableData = useContext(RoContext);
  const handleSaveCLRocontextTableData = useContext(CLRoContext);
  const [argo_analysis_val, setArgo_analysis_val] = useState({});
  const [conc_calc, setConc_Calc] = useState('');
  const [recovery_checked, setRecovery_checked] = useState(conc_calc !== 'winflows');
  const [argo_flag_val, setArgo_Flag_Val] = useState(false);
  const [alum_calc_conc_val, setAlum_Calc_Conc_Val] = useState(0);
  // Initialize 'isShowRegion' state. This state determines whether the region should be displayed or not.
  // The initial value is determined by the 'getRegionAccess' function.
  const [isShowRegion] = useState(getRegionAccess(dbTransactionDetails));
  // Initialize 'region' state. This state stores the current region. The initial value is an empty string.
  const [region, SetRegion] = useState('');
  const [product, SetProduct] = useState('UNTREATED');
  const [argo_Coagulant, setArgo_Coagulant] = useState(false);

  // Initialize 'argoProducts' state. This state stores the list of products.
  // The initial value is determined by the 'getDefaultValue' function.
  const [argoProducts, SetArgoProducts] = useState(getDefaultValue(dbTransactionDetails));
  const [argofinalProducts, SetArgoFinalProducts] = useState(argoProducts);

  // Initialize 'argoRegions' state. This state stores the list of regions. The initial value is an empty array.
  const [argoRegions, SetArgoRegions] = useState([]);
  const [argo_data_final, setArgo_data_final] = useState({});
  const [argo_data_output, setArgo_data_output] = useState({});
  const [ro_dic, setRo_Dic] = useState({
    kg_day: 0,
    ppm: 0,
  });
  let output_user_val = {}; let output_user_v; let Argo_data_cal; let Argo_output_data = {};
  const filterOrganicCoagulants = (ProductsList) => {
    SetArgoFinalProducts(ProductsList);
    const organicCoagulant = dbTransactionDetails?.antiscalant_dict?.organic_coagulant_compatible;
    if (JSON.stringify(ProductsList) === JSON.stringify(['UNTREATED', 'Hypersperse_Organic', 'Hypersperse'])) {
      const filteredProducts = ProductsList.filter(product => organicCoagulant[product] === 0);
      SetArgoProducts([...filteredProducts, 'UNTREATED']);
    }else{
      SetArgoProducts(ProductsList);
    }
  };
  const changeRegion = () => {
    SetRegion(getRegion().region);
    SetArgoProducts(Products(dbTransactionDetails, getRegion().region));
    SetArgoFinalProducts(Products(dbTransactionDetails, getRegion().region));
    SetArgoRegions(getRegion().regions);
  };
  useEffect(() => {
    // Get the payload from local storage based on the feed name
    const payload = JSON.parse(localStorage.getItem(feedName === 'RO' ? 'ro_payload' : 'clro_payload'));
    if (payload !== null && payload.ro[id] !== null && payload.ro[id] !== undefined) {
      // Get the payload for the specific 'id'
      const argo_payload = payload.ro[id];
      setArgo_analysis_val(argo_payload.argo_dict);
      setConc_Calc(argo_payload?.argo_dict?.conc_calc_mode);
      setRecovery_checked(argo_payload?.argo_dict?.conc_calc_mode !== 'winflows');
      setArgo_Flag_Val(argo_payload?.argo_dict?.argo_flag || false);
      setAlum_Calc_Conc_Val(parseFloat(argo_payload?.argo_dict?.alum_calc_conc) || 0);
      // Initialize ro_dic state with default values
      // Note: user_region selection has been removed to prevent access violations
      // When a MemChemCoE user shares a file with a non-MemChemCoE user, the non-MemChemCoE user
      // should not be able to view or access products from regions they don't have access to.
      // By removing the user_region parameter and using the current region from getRegion(),
      // we ensure that only products accessible to the current user are displayed.
      // SetRegion(getRegion().region);
      SetRegion(isShowRegion ? argo_payload?.argo_dict?.user_region || getRegion().region : getRegion().region);
      SetProduct(argo_payload?.argo_dict?.antiscalant || 'UNTREATED');
      // SetArgoProducts(Products(dbTransactionDetails, argo_payload?.argo_dict?.user_region || getRegion().region));
      // filterOrganicCoagulants(Products(dbTransactionDetails, getRegion().region));
      filterOrganicCoagulants(Products(dbTransactionDetails, isShowRegion ? argo_payload?.argo_dict?.user_region || getRegion().region : getRegion().region));
      // SetArgoFinalProducts(Products(dbTransactionDetails, argo_payload?.argo_dict?.user_region || getRegion().region));
      SetArgoRegions(getRegion().regions);
      // Save the updated payload in local storage
      saveFormDataInLocalStorage({ record: argo_payload, type: 'ro', id, item: feedName === 'RO' ? 'ro_argo_temp' : 'clro_argo_temp' });
      // Check if 'ro_ouput_data' exists in local storage
      if (localStorage.getItem('ro_ouput_data')) {
        // Parse the 'ro_ouput_data' from local storage
        output_user_val = JSON.parse(localStorage.getItem('ro_ouput_data'));
        // Get the 'ro_name' from local storage
        const ro_name = localStorage.getItem(id);
        // Get the 'output_user' data for the 'ro_name' or default to an empty object
        output_user_v = output_user_val[ro_name] || {};
        // Get the 'output_user' data or default to an empty object
        Argo_output_data = output_user_v.output_user || {};
        Argo_data_cal = Argo_output_data.argo_output || {};
        setArgo_data_output(Argo_output_data.argo_output || {});
        setArgo_data_final(Argo_data_cal?.[argo_payload?.argo_dict?.conc_calc_mode || 'winflows'] || {});
        setRecovery_checked(argo_payload?.argo_dict?.conc_calc_mode !== 'winflows');
      }
    } else {
      SetRegion(getRegion().region);
      // SetArgoProducts(Products(dbTransactionDetails, getRegion().region));
      filterOrganicCoagulants(Products(dbTransactionDetails, getRegion().region));
      // SetArgoFinalProducts(Products(dbTransactionDetails, getRegion().region));
      SetArgoRegions(getRegion().regions);
    }
  }, []);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [visibleCompareV, setVisibleCompareV] = useState(false);
  const [isShowArgoCompare, setisShowArgoCompare] = useState(false);
  const [Chartvalue, setChartValue] = useState('1');
  let kg_day_n = 0;
  let ppm_n = 0;
  useEffect(() => {
    if (argo_data_final.as_kg_day) {
      kg_day_n = `${Number(argo_data_final.as_kg_day[argo_analysis_val.antiscalant]).toFixed(2)}`;
      ppm_n = `${Number(argo_data_final.as_ppm[argo_analysis_val.antiscalant]).toFixed(2)}`;
    }
    setRo_Dic({
      kg_day: kg_day_n,
      ppm: ppm_n
    });
  }, [argo_data_final]);

  const handleCloseCompareV = () => {
    setVisibleCompareV(false);
  };
  const handleCloseIsShowArgoCompare = () => {
    setisShowArgoCompare(false);
  };
  const designGuidline = () => {
    setVisibleCompareV(true);
  };
  const ArgoAnalyzerhandleChange = (event) => {
    if (event.target.value === 'argo') {
      setRecovery_checked(true);
    } else {
      setRecovery_checked(false);
      setChartValue('1');
    }
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setConc_Calc(event.target.value);
    setRecovery_checked(event.target.value !== 'winflows');
    setArgo_data_final(argo_data_output?.[event.target.value] || {});
    if (argo_data_output?.[event.target.value].as_kg_day) {
      setRo_Dic({
        kg_day: `${Number(argo_data_output[event.target.value].as_kg_day[product]).toFixed(2)}`,
        ppm: `${Number(argo_data_output[event.target.value].as_ppm[product]).toFixed(2)}`,
      });
    } else {
      setRo_Dic({
        kg_day: 0,
        ppm: 0,
      });
    }
  };
  const showErrorMessage = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      yesOrNo: false,
      type: 'error',
      title: 'Error',
      message: translateObject('Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type'),
      onYes: () => handleCloseRo(),
      onNo: () => setModalOption(defaultModalOptions)
    });
  };

  const handleSaveArgoDictData = () => {
    // Define a function to validate fields
    const validateFields = (stagedData) => {
      return stagedData.some((obj) => {
        const { application, elementGroup, elementModel, elementsperVessel } = obj;
        return (application === '' || elementGroup === '' || elementModel === '' || elementsperVessel === 0);
      });
    };
    // Get the appropriate record and payload based on the feed name
    const record = feedName === 'RO' ? handleSaveRocontextTableData.rowData : handleSaveCLRocontextTableData.rowData;
    const payload = JSON.parse(localStorage.getItem(feedName === 'RO' ? 'ro_payload' : 'clro_payload'));

    // Filter out the records where pressureVessels is not 0
    const stagedData = record.filter((obj) => obj.pressureVessels !== 0);

    // If staged data is empty or any fields are invalid, show error message
    if (isEmpty(stagedData) || validateFields(stagedData)) {
      showErrorMessage();
    } else {
      // Save the data and update the payload
      if (feedName === 'RO') {
        handleSaveRocontextTableData.handleSaveRoTableData(record, true);
      } else {
        handleSaveCLRocontextTableData.handleSaveCLRoTableData(record, true);
      }

      if (payload !== null) {
        const argo_payload = payload.ro[id];
        argo_payload.argo_dict = {
          argo_flag: argo_flag_val,
          antiscalant: product,
          conc_calc_mode: conc_calc,
          alum_calc_conc: parseFloat(alum_calc_conc_val),
          user_region: region,
        };
        saveFormDataInLocalStorage({ record: argo_payload, type: 'ro', id, item: feedName === 'RO' ? 'ro_payload' : 'clro_payload' });
        saveFormDataInLocalStorage({ record: argo_payload, type: 'ro', id, item: feedName === 'RO' ? 'ro_argo_temp' : 'clro_argo_temp' });
      }

      // Close the Ro
      handleCloseRo();
    }
  };
  const selectRegion = (event) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    SetRegion(event.target.value);
    setArgo_Coagulant(false);
    SetArgoProducts(Products(dbTransactionDetails, event.target.value));
    SetArgoFinalProducts(Products(dbTransactionDetails, event.target.value));
    SetProduct('UNTREATED');
  };
  const selectProductChanges = (event) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (argo_data_final.as_kg_day) {
      setRo_Dic({
        kg_day: `${Number(argo_data_final.as_kg_day[event.target.value]).toFixed(2)}`,
        ppm: `${Number(argo_data_final.as_ppm[event.target.value]).toFixed(2)}`,
      });
    } else {
      setRo_Dic({
        kg_day: 0,
        ppm: 0,
      });
    }
    SetProduct(event.target.value);
  };

  const switchHandler = (event) => {
    const target = event.target.checked;
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    const argo_modalHandler = (argo_target) => {
      setModalOption(defaultModalOptions);
      setArgo_Flag_Val(argo_target);
    };
    argo_modalHandler(target);
  };
  const productTooltip = (product) => {
    switch (product) {
    case 'MDC709':
      return 'MDC 709 is a traced version of MDC 700';
    case 'MDC721':
      return 'MDC 721 is a traced version';
    case 'MDC700':
      return 'A traced version is available for this antiscalant (MDC 709)';
    // case 'MDC714':
    //   return 'A traced version is available for this antiscalant (MDC 721)';
    default:
      return ' ';
    }
  };
  const organicCoagulantLabel = (
    <>
      <span style={{ fontSize: '12px' }}><span style={{ fontWeight: 700 }}>Organic Coagulant</span></span>
      <Tooltip title='Some antiscalants are incompatible with organic coagulants.  If this box is selected, potentially incompatible antiscalants will be removed from consideration.' placement="top" arrow>
        <InfoOutlinedIcon style={{ fontSize: 14, paddingLeft: 2 }} />
      </Tooltip>
    </>);
  const handleOrganicCoagulant = (event) => {
    const organicCoagulant = dbTransactionDetails?.antiscalant_dict?.organic_coagulant_compatible;
    setArgo_Coagulant(event.target.checked);
    if (event.target.checked) {
      const filteredProducts = argofinalProducts.filter(product => organicCoagulant[product] === 1);
      SetArgoProducts(filteredProducts);
      // Handle the case when the checkbox is checked
    } else {
      SetArgoProducts(argofinalProducts);
      // Handle the case when the checkbox is unchecked for non-external user
    }
  };
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 40,
    height: 20,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 12,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#01A0B7' : '#01A0B7',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 16,
      height: 16,
      borderRadius: 10,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 45 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));
  return (
    <Box sx={{ maxWidth: '100%', borderColor: 'divider' }} className="argo-box">
      <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
      <Grid container spacing={1} style={{ 'marginTop': 0 }} className='argo-content-grid'>
        <Grid item xs={12} sm={12} md={6} lg={3.5}>
          <Grid item xs={12} style={{ padding: '0px 0px 16px 0px' }} >
            <div className="radio-input-combined">
              <AntSwitch checked={argo_flag_val} label="Activate Argo Analyzer" onChange={switchHandler} />
              <h5 className="normal-font no_drag S_heading" style={{ 'margin': '-4px 0px 0px 10px' }}>{translateObject('Activate Argo Analyzer')}</h5>
            </div>
          </Grid>
          <Grid item xs={12} className='forground-borders-blue-border' style={{ 'borderRadius': '8px', 'padding': '16px' }}>
            <Grid item xs={12} >
              <h5 className="normal-font sansW7Bld no_drag M_Bold">
                {translateObject('Concentrate composition calculated by Winflows')}</h5>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={conc_calc}
                  onChange={ArgoAnalyzerhandleChange}
                >
                  <FormControlLabel value="winflows" disabled={!argo_flag_val} className='no_drag'
                    control={<Radio size="small" />} label="Winflows" sx={{ fontSize: 12 }} />
                  <FormControlLabel value="argo" disabled={!argo_flag_val} className='no_drag'
                    control={<Radio size="small" />} label="Argo" />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid container className={!argo_flag_val ? 'argo-disabled argo-input-feilds' : 'argo-enable argo-input-feilds'}>
              {isShowRegion && <Grid item xs={12} style={{ 'padding': '0.5rem', paddingBottom: '0px' }}>
                <div className="normal-font no_drag S_Bold">{translateObject('Select Region')}</div>
                <div className='select-dropdown-argo mt-2 no_drag'>
                  <Select
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    value={region}
                    name='waterSource'
                    fullWidth
                    disabled={!argo_flag_val}
                    onChange={selectRegion}
                    data-testid='waterSource'>
                    {(argoRegions || []).map((val) => (
                      <MenuItem key={val}
                        value={val}>{val}</MenuItem>
                    ))}
                  </Select>
                </div>
              </Grid>}
              <Grid item xs={12} style={{ 'padding': '0.5rem', paddingBottom: '0px' }}>
                <div className="normal-font no_drag S_Bold" style={{ display: 'inline-flex' }}>{translateObject('Select Hypersperse Products')}
                  {productTooltip(product) !== ' ' && <Tooltip title={productTooltip(product)} placement="top" arrow>
                    {/* {(region === 'NAM'|| region === 'EMEA') && productTooltip(product) !== ' ' && <Tooltip title={productTooltip(product)} placement="top" arrow> */}
                    <InfoOutlinedIcon style={{ fontSize: 12, paddingLeft: 2 }} />
                  </Tooltip>}
                </div>
                <div className='select-dropdown-argo mt-2 no_drag'>
                  <Select
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    value={product}
                    name='waterSource'
                    fullWidth
                    disabled={!argo_flag_val}
                    onChange={selectProductChanges}
                    data-testid='waterSource'>
                    {(argoProducts || []).map((val) => (
                      <MenuItem key={val}
                        value={val}>{val}</MenuItem>
                    ))}
                  </Select>
                </div>
                <FormControlLabel control={<Checkbox size="small" onChange={handleOrganicCoagulant} disabled={!argo_flag_val} style={{ padding: '0px 9px' }} checked={argo_Coagulant} />} label={organicCoagulantLabel} />
              </Grid>
              <Grid item xs={12} style={{ 'padding': '0.5rem', paddingBottom: '0px' }} className=''>
                <div className="normal-font no_drag S_Bold">{translateObject('Aluminium in Conc (ppm)')}</div>
                <input
                  className="Form_Input_design combined-input-field mt-2 no_drag"
                  type="number"
                  name="recovery"
                  value={alum_calc_conc_val === null ? 0.00 : Number(alum_calc_conc_val)}
                  onFocus={e => e.target.select()}
                  onChange={(e) => { setIsShowErrorMessage(true); setAlum_Calc_Conc_Val(parseFloat(e.target.value)); }}
                  style={{ paddingLeft: '8px' }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className='no_drag' style={{ 'position': 'relative', 'top': isShowRegion ? '2%' : '2%', 'right': '0px' }}>
            <Stack spacing={2} direction="row">
              <Button
                variant="contained"
                size="small"
                className="sansW4SeLig M_Bold Secondary-Default_button"
                style={{ width: '120px' }}
                onClick={handleCloseRoModal}>
                {translateObject('Cancel')}
              </Button>
              <Button
                size="small"
                variant="contained"
                className="sansW4SeLig M_Bold Primary_Default_Button"
                onClick={handleSaveArgoDictData}
                style={{ fontSize: '16px' }}>
                {translateObject('OK')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={8.5} style={{ 'paddingLeft': '24px' }} >
          <Grid container className={!argo_flag_val ? 'argo-disabled' : 'argo-enable'}>
            <Grid container className={!argo_flag_val ? 'argo-disabled' : 'argo-enable'}>
              <div
                className={!argo_flag_val ? 'argo-disabled sansW7Bld forground-text-primary' :
                  'argo-enable sansW7Bld no_drag S_heading forground-text-primary'}
              >{translateObject('Results')}</div>
            </Grid>

            <Grid container className={!argo_flag_val ? 'argo-disabled' : 'argo-enable no_drag'}>
              <Grid item xs={12} sm={12} md={2} lg={2} className='mt-1 no_drag S_Regular forground-text-primary'
                style={{ display: 'flex', 'alignItems': 'center' }}>{translateObject('Antiscalant Dosage')}</Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} style={{ display: 'flex', 'alignItems': 'center' }}>
                <Grid container className="radio-input-combined">
                  <Grid item xs={3}>
                    <input
                      className="Form_Input_design combined-input-field no_drag"
                      type="string"
                      name="recovery"
                      value={ro_dic.kg_day !== 'NaN' ? ro_dic.kg_day : 'NA'}
                      onFocus={e => e.target.select()}
                      style={{ paddingLeft: '8px' }}
                      readOnly
                    />
                  </Grid>
                  <Grid item xs={9} className='unit_design'>
                    <div className="Form_Input_design_Units no_drag">
                      kg/day in Feed
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} style={{ display: 'flex', 'alignItems': 'center' }}>
                <Grid container className="radio-input-combined">
                  <Grid item xs={3}>
                    <input
                      className="Form_Input_design combined-input-field"
                      type="string"
                      name="recovery"
                      value={ro_dic.ppm !== 'NaN' ? ro_dic.ppm : 'NA'}
                      onFocus={e => e.target.select()}
                      style={{ paddingLeft: '8px' }}
                      readOnly
                    />
                  </Grid>
                  <Grid item xs={9} className='unit_design'>
                    <div className="Form_Input_design_Units">
                      ppm in Feed
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Tooltip title={translateObject('Compare')} placement="left" arrow>
                  <IconButton
                    size="small"
                    variant="contained"
                    onClick={designGuidline}
                    disabled={!(Object.keys(argo_data_final).length > 0)}
                    className="sansW4SeLig M_Bold"
                    style={{
                      color: '#fff',
                      backgroundColor: Object.keys(argo_data_final).length > 0 ? '#002D62' : '#A9A9A9', marginRight: '10px'
                    }}>
                    <BarChartIcon />
                  </IconButton>
                </Tooltip>
                {recovery_checked && conc_calc === 'argo' &&
                  <Tooltip title={translateObject('Saturation Index Heat Map')} placement="left" arrow>
                    <IconButton
                      size="small"
                      variant="contained"
                      disabled={!(Object.keys(argo_data_final).length > 0)}
                      onClick={() => setisShowArgoCompare(true)}
                      className="sansW4SeLig M_Bold" style={{
                        color: '#fff',
                        backgroundColor: Object.keys(argo_data_final).length > 0 ? '#002D62' : '#A9A9A9' // Change color when disabled
                      }}>
                      <StackedLineChartIcon />
                    </IconButton>
                  </Tooltip>}
                {visibleCompareV && (
                  <Dashboard
                    visibleCompareV={visibleCompareV}
                    handleCloseCompareV={handleCloseCompareV}
                    data={argo_data_final}
                    conc_calc={conc_calc}
                    argoProducts={argoProducts}
                    feedName={feedName}
                    translateObject={translateObject}
                  />
                )}
                {isShowArgoCompare && (
                  <ArgoDashboard
                    isShowArgoCompare={isShowArgoCompare}
                    handleCloseIsShowArgoCompare={handleCloseIsShowArgoCompare}
                    data={argo_data_final}
                    conc_calc={conc_calc}
                    product={product}
                    argoProducts={argoProducts}
                    feedName={feedName}
                    translateObject={translateObject}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ 'marginTop': '20px' }}>
            <div className={!argo_flag_val ? 'argo-disabled argo-chart-feilds' : 'argo-enable argo-chart-feilds'}>
              <Grid item xs={12}>
                <Charts recovery_checked={recovery_checked} data={argo_data_final} product={product}
                  Chartvalue={Chartvalue} setChartValue={setChartValue} feedName={feedName} />
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
